import { render, staticRenderFns } from "./render-image.vue?vue&type=template&id=52f52b2b&"
import script from "./render-image.vue?vue&type=script&lang=ts&"
export * from "./render-image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports